import type { SankeyScale } from '@revelio/replots';

import type { SankeyPlotOptions } from '../../PageConfigProvider/types/item';

export const isDevBuild = (): boolean => process.env.NODE_ENV === 'development';

export const DEFAULT_SANKEY_TOTAL_EXPONENT = 0.7;
export const DEFAULT_SANKEY_SHARE_EXPONENT = 0.7;
export const SANKEY_EXPONENT_MIN = 0.1;
const SANKEY_EXPONENT_MAX = 1;
export const SANKEY_EXPONENT_STEP = 0.05;

const clampExponent = (value: unknown, fallback: number): number =>
  typeof value === 'number' && Number.isFinite(value)
    ? Math.min(SANKEY_EXPONENT_MAX, Math.max(SANKEY_EXPONENT_MIN, value))
    : fallback;

export const resolveSankeyWidthScale = (
  options: SankeyPlotOptions | undefined
): 'linear' | 'power' =>
  options?.widthScale === 'linear' ? 'linear' : 'power';

export const resolveSankeyScale = (
  options: SankeyPlotOptions | undefined
): SankeyScale | undefined => {
  if (resolveSankeyWidthScale(options) !== 'power') return undefined;
  return {
    totalExponent: clampExponent(
      options?.totalExponent,
      DEFAULT_SANKEY_TOTAL_EXPONENT
    ),
    shareExponent: clampExponent(
      options?.shareExponent,
      DEFAULT_SANKEY_SHARE_EXPONENT
    ),
  };
};
